export const HAS_TRANSLATION_VALUES = Object.freeze({
  YES: 'YES',
  NO: 'NO',
});

export const isValidHasTranslationValue = (hasTranslation) => {
  return !!HAS_TRANSLATION_VALUES[hasTranslation];
};
